export default __webpack_public_path__ + "7076e94576376725f1094b00034bba9e.png";